
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface CurrentPuttingPointProps {
  currentPoint: string;
  currentAttempt: number;
  maxAttempts: number;
  distance: number | string;
  undoLastScore: () => void;
  hasScores: boolean;
}

const CurrentPuttingPoint = ({ 
  currentPoint, 
  currentAttempt, 
  maxAttempts, 
  distance,
  undoLastScore,
  hasScores
}: CurrentPuttingPointProps) => {
  const { t } = useTranslation('training');
  
  // Map point to distance if not provided
  let displayDistance = distance || 
    (currentPoint === 'A' ? '0.5m' : 
     currentPoint === 'B' ? '0.8m' : 
     currentPoint === 'C' ? '1m' : distance);
     
  // Convert to string with "m" if it's a number
  if (typeof displayDistance === 'number') {
    displayDistance = `${displayDistance}m`;
  }
     
  return (
    <div className="text-center mb-4 md:mb-8">
      <h3 className="text-lg md:text-xl font-semibold mb-2">
        {t('putting.currentPoint')}: {currentPoint} - {t('putting.attempt')} {currentAttempt + 1}/{maxAttempts}
      </h3>
      <p className="text-golf-600 mb-3 md:mb-4 text-sm md:text-base">
        {t('putting.distance')}: {displayDistance}
      </p>
      <Button
        onClick={undoLastScore}
        disabled={!hasScores}
        className="h-12 w-full font-medium bg-red-200 hover:bg-red-300 text-red-700 border-0"
      >
        {t('putting.cancelLastEntry')}
      </Button>
    </div>
  );
};

export default CurrentPuttingPoint;
